import { selectorFamily } from 'recoil';
import moment from 'moment';
import { startingDate } from '../atoms/startingDate';
import { endingDate } from '../atoms/endingDate';
import { agentUserId } from '../atoms/agentUserId';
import axios from '../../common/axiosInterceptor';
import { groupingState } from '../atoms/grouping';
import { user } from '../atoms/user';
import { methodNameEnum } from './makePHPRequest';
import { endpointEnum } from '../../services/rest/makeAPIRequest';
import { getApiMutation } from '../../services/rest/getApiMutation';

export const getAgentReport = selectorFamily({
  key: 'getAgentReport',
  get: ({ urlStartingDate, urlEndingDate, accessToken }) => async ({ get }) => {
    try {
      const User = get(agentUserId);
      const startdate = get(startingDate);
      const enddate = get(endingDate);
      const { grouping } = get(groupingState);
      const storageUser = get(user);
      const data = {
        call: methodNameEnum.GET_BUSINESS_DATA,
      };
      const mutation = getApiMutation(storageUser);
      const businessData = await mutation({
        endpoint: endpointEnum.GET_BUSINESS_DATA,
        payload: data,
      });
      if (Number(User.id) >= 0) {
        // using production
        const result = await axios.post(
          `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/getbusinessuserreporting2`,
          JSON.stringify({
            businessId: storageUser.businessid,
            businessid: storageUser.businessid,
            apiKey: storageUser.apikey,
            apikey: storageUser.apikey,
            call: 'getBusinessUsersReporting',
            connectionLimit: businessData.data.result[0].connectionDuration,
            startdate,
            enddate,
            timezone: businessData.data.result[0].timezone_php,
          }),
          {
            headers: {
              Authorization: accessToken, // accessToken in recoil maybe stale
              'x-api-key': storageUser.apikey,
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
          }
        );
        // TODO: the below request causes infinite loop
        // const result = get(
        //   makeAPIRequest({
        //     endpoint: endpointEnum.GET_BUSINESS_USER_REPORTING,
        //     payloadJsonString: JSON.stringify({
        //       call: 'getBusinessUsersReporting',
        //       businessid: storageUser.businessid,
        //       apiKey: storageUser.apikey,
        //       connectionLimit: businessData.data.result[0].connectionDuration,
        //       startdate,
        //       enddate,
        //       timezone: businessData.data.result[0].timezone_php,
        //     })
        //   })
        // );
        // TODO: the below is an invalid hook call outside of a react function
        // const result = useRecoilValueLoadable(
        //   makeAPIRequest({
        //     endpoint: endpointEnum.GET_BUSINESS_USER_REPORTING,
        //     payloadJsonString: JSON.stringify({
        //       call: 'getBusinessUsersReporting',
        //       businessid: storageUser.businessid,
        //       apiKey: storageUser.apikey,
        //       connectionLimit:
        //         businessData?.data?.result?.[0]?.connectionDuration,
        //       startdate,
        //       enddate,
        //       timezone: businessData?.data?.result?.[0]?.timezone_php,
        //     }),
        //   })
        // );
        // for total Calls chart
        const totalCallsArray = [];
        const totalsCalls = [
          {
            title: 'Outgoing',
            key: 'alloutgoing',
          },
          {
            title: 'Incoming',
            key: 'allincoming',
          },
          {
            title: 'Connections',
            key: 'allconnections',
          },
          {
            title: 'Missed',
            key: 'allmissed',
          },
        ];
        const totalCallsOptions = {
          chart: {
            height: 400,
            type: 'spline',
          },
          title: {
            text: 'Total Calls',
          },
          xAxis: {
            crosshair: true,
            type: 'datetime',
          },
          yAxis: {
            title: {
              text: 'Call Volume',
            },
          },
          tooltip: {
            shared: true,
          },
          credits: {
            enabled: false,
          },
          series: [],
          plotOptions: {
            series: {
              pointStart: 0,
              pointInterval: 1,
            },
          },
        };
        // for totals outgoing
        const totalOutgoingArray = [];
        const totalsOutgoing = [
          {
            title: 'Calls',
            key: 'alloutgoing',
          },
          {
            title: 'Answered',
            key: 'outgoinganswered',
          },
          {
            title: 'Connections',
            key: 'outgoingconnection',
          },
        ];
        const totalOutgoingOptions = {
          chart: {
            height: 400,
            type: 'spline',
          },
          title: {
            text: 'Totals Outgoing',
          },
          xAxis: {
            crosshair: true,
            type: 'datetime',
          },
          yAxis: {
            title: {
              text: 'Call Volume',
            },
          },
          tooltip: {
            shared: true,
          },
          credits: {
            enabled: false,
          },
          series: [{}],
        };
        // for totals incoming
        const totalIncomingArray = [];
        const totalsIncoming = [
          {
            title: 'Calls',
            key: 'allincoming',
          },
          {
            title: 'Answered',
            key: 'incominganswered',
          },
          {
            title: 'Connection',
            key: 'incomingconnection',
          },
          {
            title: 'Missed',
            key: 'incomingmissed',
          },
        ];
        const totalIncomingOptions = {
          chart: {
            height: 400,
            type: 'spline',
          },
          title: {
            text: 'Totals Incoming',
          },
          xAxis: {
            crosshair: true,
            type: 'datetime',
          },
          yAxis: {
            title: {
              text: 'Call Volume',
            },
          },
          tooltip: {
            shared: true,
          },
          credits: {
            enabled: false,
          },
          series: [{}],
        };
        let chartData = {};
        if (result) {
          if (result?.data?.charts?.[Number(User?.id)]) {
            chartData = result?.data?.charts[Number(User?.id)];
          }
          switch (grouping) {
            case 'Week':
              totalsCalls.forEach((i) => {
                const totalCallsObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalCallsObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedWeek = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('week').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedWeek[0]) {
                    totalCallsOptions.plotOptions = {
                      series: {
                        pointStart: +chartDataReducedWeek[0][0],
                        pointInterval: 24 * 7 * 3600 * 1000,
                        pointIntervalUnit: 'week',
                      },
                    };
                  }
                  totalCallsObj.data = chartDataReducedWeek;
                  totalCallsArray.push(totalCallsObj);
                }
              });
              totalsOutgoing.forEach((i) => {
                const totalOutgoingObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalOutgoingObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedWeek = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('week').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedWeek[0]) {
                    totalCallsOptions.plotOptions = {
                      series: {
                        pointStart: +chartDataReducedWeek[0][0],
                        pointInterval: 24 * 7 * 3600 * 1000,
                        pointIntervalUnit: 'week',
                      },
                    };
                  }
                  totalOutgoingObj.data = chartDataReducedWeek;
                  totalOutgoingArray.push(totalOutgoingObj);
                }
              });
              totalsIncoming.forEach((i) => {
                const totalIncomingObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalIncomingObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedWeek = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('week').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedWeek[0]) {
                    totalIncomingOptions.plotOptions = {
                      series: {
                        pointStart: +chartDataReducedWeek[0][0],
                        pointInterval: 24 * 7 * 3600 * 1000,
                        pointIntervalUnit: 'week',
                      },
                    };
                  }
                  totalIncomingObj.data = chartDataReducedWeek;
                  totalIncomingArray.push(totalIncomingObj);
                }
              });
              break;
            case 'Month':
              totalsCalls.forEach((i) => {
                const totalCallsObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalCallsObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedMonth = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('month').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedMonth[0]) {
                    totalCallsOptions.plotOptions = {
                      series: {
                        pointStart: chartDataReducedMonth[0][0],
                        pointIntervalUnit: 'month',
                      },
                    };
                  }
                  totalCallsObj.data = chartDataReducedMonth;
                  totalCallsArray.push(totalCallsObj);
                }
              });
              totalsOutgoing.forEach((i) => {
                const totalOutgoingObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalOutgoingObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedMonth = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('month').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedMonth[0]) {
                    totalCallsOptions.plotOptions = {
                      series: {
                        pointStart: chartDataReducedMonth[0][0],
                        pointIntervalUnit: 'month',
                      },
                    };
                  }
                  totalOutgoingObj.data = chartDataReducedMonth;
                  totalOutgoingArray.push(totalOutgoingObj);
                }
              });
              totalsIncoming.forEach((i) => {
                const totalIncomingObj = {};
                // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                totalIncomingObj.name = i.title;
                if (chartData[i.key]) {
                  const chartDataReducedMonth = Object.entries(
                    chartData[i.key]
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('month').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  if (chartDataReducedMonth[0]) {
                    totalIncomingOptions.plotOptions = {
                      series: {
                        pointStart: chartDataReducedMonth[0][0],
                        pointIntervalUnit: 'month',
                      },
                    };
                  }
                  totalIncomingObj.data = chartDataReducedMonth;
                  totalIncomingArray.push(totalIncomingObj);
                }
              });
              break;
            default:
              if (chartData) {
                totalsCalls.forEach((i) => {
                  const totalCallsObj = {};
                  totalCallsObj.name = i.title;
                  // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                  if (chartData[i.key]) {
                    const agentData = Object.entries(
                      chartData[i.key]
                        .map((item) => [
                          Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                          item[1],
                        ])
                        .reduce(
                          (acc, [date, amount]) => ({
                            ...acc,
                            [date]: amount + (acc[date] ? acc[date] : 0),
                          }),
                          {}
                        )
                    ).map((item) => [+item[0], item[1]]);
                    if (agentData[0]) {
                      totalCallsOptions.plotOptions = {
                        series: {
                          pointStart: agentData[0][0],
                          pointInterval: 1,
                        },
                      };
                    }
                    totalCallsObj.data = agentData;
                    totalCallsArray.push(totalCallsObj);
                  }
                });
                totalsOutgoing.forEach((i) => {
                  const totalOutgoingObj = {};
                  // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                  totalOutgoingObj.name = i.title;
                  if (chartData[i.key]) {
                    const defaultData = Object.entries(
                      chartData[i.key]
                        .map((item) => [
                          Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                          item[1],
                        ])
                        .reduce(
                          (acc, [date, amount]) => ({
                            ...acc,
                            [date]: amount + (acc[date] ? acc[date] : 0),
                          }),
                          {}
                        )
                    ).map((item) => [+item[0], item[1]]);
                    if (defaultData[0]) {
                      totalOutgoingOptions.plotOptions = {
                        series: {
                          pointStart: defaultData[0][0],
                          pointInterval: 1,
                        },
                      };
                    }

                    totalOutgoingObj.data = defaultData;
                    totalOutgoingArray.push(totalOutgoingObj);
                  }
                });
                totalsIncoming.forEach((i) => {
                  const totalIncomingObj = {};
                  // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
                  totalIncomingObj.name = i.title;
                  if (chartData[i.key]) {
                    const defaultData = Object.entries(
                      chartData[i.key]
                        .map((item) => [
                          Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                          item[1],
                        ])
                        .reduce(
                          (acc, [date, amount]) => ({
                            ...acc,
                            [date]: amount + (acc[date] ? acc[date] : 0),
                          }),
                          {}
                        )
                    ).map((item) => [+item[0], item[1]]);
                    if (defaultData[0]) {
                      totalIncomingOptions.plotOptions = {
                        series: {
                          pointStart: defaultData[0][0],
                          pointInterval: 1,
                        },
                      };
                    }
                    totalIncomingObj.data = defaultData;
                    totalIncomingArray.push(totalIncomingObj);
                  }
                });
              }
          }
          totalCallsOptions.series = totalCallsArray;
          totalOutgoingOptions.series = totalOutgoingArray;
          totalIncomingOptions.series = totalIncomingArray;
          return {
            agentReporting: {
              totalCalls: totalCallsOptions,
              totalOutgoing: totalOutgoingOptions,
              totalIncoming: totalIncomingOptions,
            },
            name: User.name,
          };
        } else {
          return [];
        }
      } else {
        const result = [];
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
